<script>
export default {
  props: ['msg'],
};
</script>

<template>
  <div v-html="msg"></div>
</template>
